export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2022.9ae20c55.pdf";